import { SVGProps } from "react";

export function Menu(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.3333 3.16675H4.66666C3.93028 3.16675 3.33333 3.7637 3.33333 4.50008V13.1667C3.33333 13.9031 3.93028 14.5001 4.66666 14.5001H11.3333C12.0697 14.5001 12.6667 13.9031 12.6667 13.1667V4.50008C12.6667 3.7637 12.0697 3.16675 11.3333 3.16675Z"
        stroke="currentColor"
        strokeWidth="0.6"
      />
      <path
        d="M6 6.5H10M6 9.16667H10M6 11.8333H8.66667"
        stroke="currentColor"
        strokeWidth="0.6"
        strokeLinecap="round"
      />
    </svg>
  );
}
